/**
 * Вид загрузчика (экран обработки `loader_processing`) — одна дверь для
 * стиль-пака (`StylePackLoader.style`) и для своего поля воронки
 * `settings.quizLoader` (слово владельца 21.10.2026,
 * components/quiz-runtime/quizLoader.ts). Смысл видов — у типа пака
 * (stylePack.types.ts, `StylePackLoader`).
 *
 * Перечень сверяет со схемой сервера сторож quiz-loader.ends.spec.ts.
 */
export const LOADER_STYLES = [
  'stacked-stages',
  'all-stages',
  'ring',
  'plain-bar',
] as const;

export type LoaderStyle = (typeof LOADER_STYLES)[number];
